import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Col, Row } from "reactstrap";
import FormModal from "../../../../core/ui/components/FormModal";
import InputController from "../../../../core/ui/components/InputController";
import SelectController from "../../../../core/ui/components/SelectController";
import { selectEmpleados } from "../../../Personas/services/empleados-service";
import { crearInvolucrado } from "../../services/involucrado-service";
import { selectSoftware } from "../../services/software-service";

const FormInvolucrados = ({ modalState, onSave }) => {
    const [empleados, setEmpleados] = useState([]);
    const [software, setSoftware] = useState([]);

    useEffect(async () => {
        const resp = await selectEmpleados();
        if (!resp.status) return toast.error(resp.message);

        setEmpleados(
            resp.data.map((empleado) => {
                return {
                    label: empleado.info_persona,
                    value: empleado.id,
                };
            })
        );
    }, []);

    useEffect(async () => {
        const resp = await selectSoftware();
        if (!resp.status) return toast.error(resp.message);

        setSoftware(
            resp.data.map((software) => {
                return {
                    label: software.nombre,
                    value: software.id,
                };
            })
        );
    }, []);

    const form = useForm();

    const onCreateInvolucrado = async (involucrado) => {
        const resp = await crearInvolucrado({
            ...involucrado,
            software_id: involucrado.software_id.value,
            supervisor: involucrado.supervisor.value,
            desarrollador: involucrado.desarrollador.value,
        });
        if (!resp.status) return toast.error(resp.message);

        toast.success(resp.message);
        modalState.close();
        onSave();
    };

    return (
        <FormModal
            size="lg"
            form={form}
            id="formInvolucrados"
            isOpen={modalState.show}
            onSubmit={onCreateInvolucrado}
            headerTitle={modalState.title}
            closeModal={() => modalState.set({ show: false })}
        >
            <Row>
                <InputController
                    name="id"
                    type="hidden"
                    errors={form.formState.errors}
                    control={form.control}
                />
                <Col sm={12}>
                    <SelectController
                        errors={form.formState.errors}
                        name="software_id"
                        label="Software"
                        control={form.control}
                        options={software}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
            <Row>
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        name="desarrollador"
                        label="Desarrollador"
                        control={form.control}
                        options={empleados}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
                <Col sm={6}>
                    <SelectController
                        errors={form.formState.errors}
                        name="supervisor"
                        label="Supervisor"
                        control={form.control}
                        options={empleados}
                        rules={{
                            required: "Este campo es requerido",
                        }}
                    />
                </Col>
            </Row>
        </FormModal>
    );
};

FormInvolucrados.propTypes = {
    modalState: PropTypes.object,
    onSave: PropTypes.func
}

export default FormInvolucrados;
